import { BASE_URL } from "@/constants/endpoints";
import { ExternalTransferDetail } from "@/pages/requests/external-transfer/schema/external-transfer.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let externalTransferApiPromise: Promise<AxiosInstance> | null = null;

const getExternalTransferApi = async (): Promise<AxiosInstance | null> => {
  if (externalTransferApiPromise) return externalTransferApiPromise;
  externalTransferApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return externalTransferApiPromise;
};

export interface GetExternalTransferRequestsProps {
  Fecha?: string;
  estados?: number[];
  titular?: string;
  nroCuenta?: string;
  cuentaDestino?: string;
  monto?: number;
  solicitante?: string;
  programadas?: boolean;
  FechaEjecucion?: string;
  "P.Pagina": number;
  "P.Records": number;
}

export const getExternalTransferRequests = async (
  props: GetExternalTransferRequestsProps,
) => {
  const api = await getExternalTransferApi();
  if (!api) return null;

  const response = await api.get(
    `/TransferenciasExternas?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getExternalTransferRequest = async (
  id: number,
): Promise<ExternalTransferDetail | null> => {
  const api = await getExternalTransferApi();
  if (!api) return null;

  const response = await api.get(`/TransferenciasExternas/${id}`);

  return response.data;
};
